import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'paymentMethods.title',
    defaultMessage: 'Payment Methods',
  },
  note: {
    id: 'paymentMethods.note',
    defaultMessage:
      'Some of these payment methods might not be supported in your country.',
  },
  infoLink: {
    id: 'paymentMethods.infoLink',
    defaultMessage: 'Learn more',
  },
});
